import { Switch, BrowserRouter, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { ThemeProvider, StyledEngineProvider } from '@mui/material';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GOOGLE_OAUTH } from './constants/googleAuth';

import DownloadMUI from './views/download';
import ResetPassword from './views/ResetPassword';
import Admin from './layouts/Admin';
import history from './common/history';
import AuthenticatedRoute from './common/AuthenticatedRoute';
import theme from './styles/theme';
import { ToastMessage } from './components';
import { hideToast } from './redux/reducers/toastReducer';

function App() {
  const dispatch = useDispatch();
  const userType = useSelector((state) => state.userReducer.decodeToken.user.userType);
  const isAuthenticated = useSelector((state) => state.userReducer.isAuthenticated);
  const sessionExpired = useSelector((state) => state.userReducer.sessionExpired);

  // TODO: Update the old places where the toast was not being used from redux
  const { toastReducer } = useSelector((state) => state);

  const clientId = GOOGLE_OAUTH.CLIENT_ID;

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <GoogleOAuthProvider clientId={clientId}>
          <BrowserRouter>
            <ConnectedRouter history={history}>
              <Switch>
                <Route path="/reset-password" component={ResetPassword} />
                <Route path="/download" component={DownloadMUI} />
                <AuthenticatedRoute
                  path="/"
                  component={Admin}
                  appProps={{ isAuthenticated, userType, sessionExpired }}
                />
              </Switch>

              <ToastMessage
                open={toastReducer.open}
                handleOpen={() => dispatch(hideToast())}
                severity={toastReducer.type}
                text={toastReducer.text}
              />
            </ConnectedRouter>
          </BrowserRouter>
        </GoogleOAuthProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
